import { parseISO } from 'date-fns';
import ReactDOMServer from 'react-dom/server';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import { type TravelTimeStatus } from '../Sources/TravelTimeStatusSource';

export default function TravelTime(properties: TravelTimeStatus): string {
    function trafficStatusText(status: string) {
        switch (status) {
            case 'freeflow':
                return 'Normal framkomlighet';
            case 'heavy':
                return 'Långsam trafik';
            case 'congested':
                return 'Mycket långsam trafik';
            case 'impossible':
                return 'Stillastående trafik';
            default:
                return 'Aktuell data saknas';
        }
    }

    return ReactDOMServer.renderToStaticMarkup(
        <div className="tooltip">
            <strong>{properties.name}</strong>

            {properties.status && properties.status !== 'unknown' ? (
                <>
                    <p>
                        {trafficStatusText(properties.status)} {!!properties.speed && `(${properties.speed} km/tim)`}
                    </p>

                    <dl className="tooltip-details">
                        <dt>Uppdaterad:</dt>
                        <dd>
                            {properties.measureTime && (
                                <TimeElement date={parseISO(properties.measureTime)}>
                                    {capitalizeFirstLetter(formatCloseRelative(parseISO(properties.measureTime)))}
                                </TimeElement>
                            )}
                        </dd>
                    </dl>
                </>
            ) : (
                <p>Aktuell data saknas</p>
            )}
        </div>,
    );
}
